/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO para las estadísticas agregadas de un jugador en una temporada.
 */
export interface PlayerSeasonStatsDTO { 
    total_matches_played: number;
    total_goals: number;
    total_yellow_cards: number;
    total_2min_exclusions: number;
    total_red_cards: number;
    total_blue_cards: number;
    goals_per_match?: number;
}

